module.exports = __webpack_public_path__ + "img/taokouling.979d4bd8.png";